// extracted by mini-css-extract-plugin
module.exports = {"container":"sold-by-partner-info_container__DIpha","text":"sold-by-partner-info_text__TziG4","sizingWrapper":"sold-by-partner-info_sizingWrapper__Pr5aG"};